import { render, staticRenderFns } from "./EventBoothPage.vue?vue&type=template&id=45aac2f8"
import script from "./EventBoothPage.vue?vue&type=script&lang=js"
export * from "./EventBoothPage.vue?vue&type=script&lang=js"
import style0 from "./EventBoothPage.vue?vue&type=style&index=0&id=45aac2f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports